import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';


// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// 

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HotToastService } from '@ngneat/hot-toast';

// Jquery?
import * as $ from "jquery"
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { AllRecipients } from 'src/app/shared/models/allRecipients.model';


@Component({
  selector: 'app-system-notices',
  templateUrl: './system-notices.component.html',
  styleUrls: ['./system-notices.component.scss']
})
export class SystemNoticesComponent implements OnInit {



   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;


  subject_com_types: any;
  subject_com_type_id: any;
  subject_template_docs: Object;

  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  system_automation: Object;
  system_automations: any;


  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

   // Function below pushes form to allRecipients array, and closes window.
   @Output('addRecipientFromModal') addRecipientFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addAutomationFromModal') addAutomationFromModal: EventEmitter<any> = new EventEmitter();
   model: AllRecipients;
   
   public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  system_log_type_automations: Object;
  system_log_type_automation_triggers: Object;
  get_latest_system_automation_id: Object;
  system_notices: Object;


  constructor(
        private http: HttpClient, private router: Router, private _demoService: DemoService,
        public datepipe: DatePipe,
        private route: ActivatedRoute,
        public toastr: HotToastService,
        public gfunc: GlobalFunctionsService   
  ) { 


        // syncfusion GRID OPTIONS
        this.toolbarOptions = ['Search'];
        this.initialPage = { pageSize: 5 };
        this.filterOptions = {
        type: 'Menu'
        };
        // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
        this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};

        this.wrapSettings = { wrapMode: 'Content' };
        // end grid options

 

  }

  ngOnInit(): void {

 // get system notices.
this.getSystemNotices();

  }



  getSystemNotices() {
    this._demoService.getSystemNotices()
      .subscribe(
        res => this.system_notices = res,
        err => console.error(err.status)
      );
  }





 // Grid Functions
 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.getSystemNotices();
  this.grid.refresh();
};







}
